import axios from "axios";

const url = "https://rnapi.ghorbany.dev/api";
const url2 = "https://hamyarinoorapi.hsprojects.ir/api";

axios.defaults.headers.post["Content-Type"] = "application/json";

export default {
    get: axios.get,
    post: axios.post,
    url,
    url2
};
